import { render, staticRenderFns } from "./Monitores.vue?vue&type=template&id=38eb77a7&"
import script from "./Monitores.vue?vue&type=script&lang=ts&"
export * from "./Monitores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports